// extracted by mini-css-extract-plugin
export default {"content":"Content_content__1KRUE","wrapper":"Content_wrapper__WolCo"};